// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class CostReviewPlannedCosts {
  itemName: string;
  itemCost: number;
  tdcPercent: number;
  target: number;
  riskDisplayText: number;
  targetVisible: boolean;
  nationalHistoricTDCPercent: number;
  nationalHistoricTDCPercent50_150: number;
  nationalHistoricTDCPercentGreater150: number;
  isNationalHistoricalHidden: boolean;
  positionId: number;
  hours: number;
}
